import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class UpArrowIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 20 20"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="M 16.5,13 L 13.25,13 13.25,19 6.75,19 6.75,13 3.5,13 10,1 16.5,13 Z"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5,
						stroke: "#000000",
						strokeWidth: 1,
						strokeOpacity: 1
					}}/>
			</svg>
		);
	}
}